import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import find from 'lodash/find';
import get from 'lodash/get';
import isBoolean from 'lodash/isBoolean';
import { format as currencyFormat } from 'currency-formatter';
import ModalPortal from '../ModalPortal';
import * as analytics from '../../services/analytics';
import './Passport360EnrollmentAddOnsView.css';

const propTypes = {
  client: PropTypes.object,
  plans: PropTypes.array,
  plansFilter: PropTypes.object,
  onSubmit: PropTypes.func,
  updatePlansFilter: PropTypes.func,
};

class Passport360EnrollmentAddOnsView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalTitle: null,
      modalBody: null,
    };
    this.golfObjPath = 'settings.details.optional_coverages.golf_package';
    this.tripCancellationObjPath =
      'settings.details.optional_coverages.trip_cancellation';
  }

  componentDidMount() {
    analytics.page('Passport 360 - Enrollment Add Ons');
  }

  handleUpdate = (e) => {
    analytics.track('Passport 360 - Add On Clicked', {
      label: e.target.name,
      value: e.target.checked ? 1 : 0,
    });
    this.props.updatePlansFilter({
      [e.target.name]: e.target.checked,
    });
  };

  handleSkip = (e) => {
    e.preventDefault();
    analytics.track('Passport 360 - Add Ons Skipped');
    this.props.updatePlansFilter({
      golfPackage: false,
      tripCancellation: false,
    });
    this.props.onSubmit();
  };

  handleSubmit = () => {
    analytics.track('Passport 360 - Add Ons Next Clicked', {
      golfPackage: this.props.plansFilter.golfPackage,
      tripCancellation: this.props.plansFilter.tripCancellation,
    });
    this.props.onSubmit();
  };

  getCoverageDetailsValue(value) {
    if (isBoolean(value)) {
      return value ? 'Included' : 'Not Included';
    } else {
      return value || 'n/a';
    }
  }

  showInfoModal = (e) => {
    analytics.page('Passport 360 - Add Ons Details Modal Opened', {
      title: e.currentTarget.dataset.modalTitle,
    });
    this.setState(
      {
        modalTitle: e.currentTarget.dataset.modalTitle,
        modalBody: e.currentTarget.dataset.modalBody,
      },
      () => {
        window.$(this.modal).modal('show');
      }
    );
  };

  trackDocClick = (e) => {
    analytics.track('Broker Portal - External Link Clicked', {
      label: e.target.dataset.key,
    });
  };

  get addOns() {
    const addOnsArr = [];
    const golfPackage = find(
      this.filteredPlans,
      (plan) =>
        get(plan, this.golfObjPath) && !get(plan, this.tripCancellationObjPath)
    );
    const tripCancellation = find(
      this.filteredPlans,
      (plan) =>
        get(plan, this.tripCancellationObjPath) && !get(plan, this.golfObjPath)
    );
    if (golfPackage) {
      addOnsArr.push({
        plan: golfPackage,
        addon: get(golfPackage, this.golfObjPath),
        key: 'golfPackage',
      });
    }
    if (tripCancellation) {
      addOnsArr.push({
        plan: tripCancellation,
        addon: get(tripCancellation, this.tripCancellationObjPath),
        key: 'tripCancellation',
      });
    }
    return addOnsArr;
  }

  get filteredPlans() {
    return filter(this.props.plans, {
      settings: {
        details: {
          plan_type: this.props.plansFilter.planType,
          plan_name: this.props.plansFilter.planName,
        },
      },
    });
  }

  get title() {
    const { actor, client } = this.props;
    if (actor === 'broker') {
      return `Would ${client.person.first_name} like to add additional coverage?`;
    } else {
      return 'Would you like to add additional coverage?';
    }
  }

  render() {
    const { plansFilter } = this.props;
    return !this.addOns.length ? (
      <Redirect to="checkout" />
    ) : (
      <div className="Passport360EnrollmentAddOnsView container">
        <div className="row justify-content-center">
          <div className="col-md-7 p-t-30">
            <h3 className="text-center semi-bold">{this.title}</h3>
            <a
              href="#skip"
              className="Passport360EnrollmentAddOnsView-skipLink text-complete"
              onClick={this.handleSkip}
            >
              Continue without additional coverage →
            </a>
            <div className="row">
              {this.addOns.map((option) => (
                <div
                  className="Passport360EnrollmentAddOnsView-col"
                  key={option.key}
                >
                  <div className="Passport360EnrollmentAddOnsView-card card">
                    <div className="Passport360EnrollmentAddOnsView-card-checkbox checkbox check-success">
                      <input
                        id={`checkbox-${option.key}`}
                        type="checkbox"
                        name={option.key}
                        checked={get(plansFilter, option.key) || false}
                        onChange={this.handleUpdate}
                      />
                      <label htmlFor={`checkbox-${option.key}`}>
                        <span className="Passport360EnrollmentAddOnsView-card-checkbox-labelContent">
                          <strong>Yes</strong>, I'd like to add the{' '}
                          {option.addon.title}
                        </span>
                        <span className="Passport360EnrollmentAddOnsView-card-checkbox-price">
                          {currencyFormat(option.addon.price, {
                            code: option.plan.currency,
                            precision: 0,
                          })}
                        </span>
                      </label>
                    </div>
                    <p className="Passport360EnrollmentAddOnsView-card-description">
                      {option.addon.description}
                    </p>
                    <a
                      href={option.plan.settings.sample_policy_url}
                      className="Passport360EnrollmentAddOnsView-card-policyLink text-complete"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-key={option.key}
                      onClick={this.trackDocClick}
                    >
                      <i className="Passport360EnrollmentAddOnsView-card-policyLink-icon fal fa-file-alt" />
                      view sample policy
                    </a>
                    <table className="Passport360EnrollmentAddOnsView-table table table-striped">
                      <thead>
                        <tr>
                          <th>Benefits</th>
                          <th>Benefit amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {option.addon.benefits.map((benefit) => (
                          <tr key={benefit.title}>
                            <td>
                              {benefit.title}{' '}
                              {benefit.description && (
                                <span
                                  data-modal-title={benefit.title}
                                  data-modal-body={benefit.description}
                                  onClick={this.showInfoModal}
                                >
                                  <i className="Passport360EnrollmentAddOnsView-table-infoIcon fas fa-info-circle" />
                                </span>
                              )}
                            </td>
                            <td>{benefit.value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <button
            className="btn btn-large btn-complete"
            onClick={this.handleSubmit}
          >
            Next
          </button>
        </div>

        <ModalPortal>
          <div className="modal" id="infoModal" ref={(c) => (this.modal = c)}>
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content-wrapper">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">{this.state.modalTitle}</h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <p>{this.state.modalBody}</p>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="submit"
                      className="btn btn-complete"
                      data-dismiss="modal"
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalPortal>
      </div>
    );
  }
}

Passport360EnrollmentAddOnsView.propTypes = propTypes;

export default Passport360EnrollmentAddOnsView;
